import CurrentListsScreen from "@/screens/CurrentListsScreen";

export default CurrentListsScreen;
